import { mapRecord, memo, projectFieldWithEnv } from '@morphic-ts/common/es6/utils';
import { getStructShow } from 'fp-ts/Show';
import { showApplyConfig } from '../config';
import { ShowType, ShowURI } from '../hkt';
const asPartialShow = (x) => x;
const showOrUndefined = (s) => ({
    show: x => (x === undefined ? 'undefined' : s.show(x))
});
/**
 *  @since 0.0.1
 */
export const showObjectInterpreter = memo(() => ({
    _F: ShowURI,
    interface: (props, _name, config) => env => {
        const shows = projectFieldWithEnv(props, env)('show');
        return new ShowType(showApplyConfig(config)(getStructShow(shows), env, { shows }));
    },
    partial: (props, _name, config) => env => {
        const shows = mapRecord(projectFieldWithEnv(props, env)('show'), showOrUndefined);
        return new ShowType(showApplyConfig(config)(asPartialShow(getStructShow(shows)), env, { shows }));
    },
    both: (props, pprops, _name, config) => env => {
        const shows = projectFieldWithEnv(props, env)('show');
        const showsPartial = mapRecord(projectFieldWithEnv(pprops, env)('show'), showOrUndefined);
        return new ShowType(showApplyConfig(config)(getStructShow(Object.assign(Object.assign({}, shows), showsPartial)), env, { shows, showsPartial }));
    }
}));
